import Component from './Helmet.component';

export default Component;
